<template>
  <div class="flex flex-col items-center px-4 pt-2 pb-8 h-full justify-between">
    <div class="flex flex-col items-center h-fit">
      <div
        class="relative flex flex-col justify-center items-center bg-NAVY-BLUE px-4 pt-6 pb-6 rounded-lg h-full"
      >
        <PirateFigure :image-url="imageUrl" class="!w-[58px]" black-shadow></PirateFigure>
      </div>
      <div class="flex flex-col">
        <p class="text-lg font-semibold pt-6">{{ itemInfo.name }}</p>
        <p class="text-xs text-GREY pt-1">Level {{ itemInfo.level || 1 }}</p>
        <p class="text-sm font-normal pt-3">
          {{ itemInfo.description }}
        </p>
      </div>
    </div>
    <div class="flex flex-col gap-6 pt-3 items-center w-full pb-3">
      <div class="flex flex-row gap-2 items-center">
        <p class="text-GREY text-sm">Profit per hour</p>
        <div class="flex flex-row items-center">
          <img class="w-5" src="@/assets/icons/token-2.svg" />
          <p class="font-semibold text-sm ps-1">{{ itemInfo.level ? itemInfo.token_per_hour : 0 }}</p>
          <div v-if="!itemInfo.maxLevel" class="flex flex-row items-center">
            <font-awesome-icon class="black-icon px-2" :icon="['fas', 'angles-right']" />
            <p class="font-semibold text-GREEN">{{ itemInfo.level ? itemInfo.next_token_per_hour : itemInfo.token_per_hour }}</p>
          </div>
        </div>
      </div>
      <pow-button
        v-if="!itemInfo.level"
        secondary
        class="w-full"
        :loading="loading"
        @click="buyCard(itemInfo)"
      >
        <div class="flex flex-row gap-1">
          <p>Buy for </p>
          <img class="w-5" src="@/assets/icons/token-2.svg" />
          <p>{{ itemInfo.buy_price }}</p>
        </div>
      </pow-button>
      <pow-button
        v-else-if="itemInfo.level && itemInfo.level <= itemInfo.max_level"
        secondary
        class="w-full"
        :loading="loading"
        @click="buyCard(itemInfo)"
      >
        <div class="flex flex-row gap-1">
          <p>Upgrade to Lv. {{ itemInfo.level + 1 }}</p>
          <img class="w-5" src="@/assets/icons/token-2.svg" />
          <p>{{ itemInfo.upgrade_price }}</p>
        </div>
      </pow-button>
      <pow-button
        v-else-if="itemInfo.level >= itemInfo.max_level"
        secondary
        class="w-full opacity-50"
        :loading="loading"
      >
        <p>Max Level</p>
      </pow-button>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

import PowButton from '@/components/PowButton.vue'
import PirateFigure from '../PirateFigure.vue'
import { updateCard } from '@/services'
import { useGameStore } from '@/stores/game'
import { closeBottomDrawer } from '@/composables/bottomdrawer'

const gameStore = useGameStore()
const loading = ref(false)

const buyCard = async (item) => {
  const action = item.level > 0 ? 'upgrade' : 'buy'
  loading.value = true
  const res = await updateCard({
    action,
    id: item.id
  })
  gameStore.fetchUserSync()
  closeBottomDrawer()
  loading.value = false
}

const props = defineProps({
  itemInfo: {
    type: Object,
    required: true
  }
})

const imageUrl = computed(
  () => new URL(`../../assets/images/${props.itemInfo.image}`, import.meta.url).href
)
</script>
